<template>
  <div class="modal fade" :id="id" tabindex="-1">
    <div class="modal-dialog">
      <form @submit.prevent="submitForm" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t('absences.setting.modals.create_public_holidays')}}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor" />
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor" />
                    </svg>
                  </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />
            <Card containerClass="mb-5 shadow-sm" bodyClass="py-3" titleContainerClass="d-flex justify-content-center">
              <template #cardBody>
                <div class="d-flex justify-content-between align-items-center">
                  <span class="fs-3 fw-bold">{{$t('absences.setting.modals.date_to_change')}}</span>

                  <div class="form-check form-switch form-check-custom form-check-solid">
                    <input class="form-check-input" type="checkbox" v-model="formData.constant" id="flexSwitchDefault"/>
                  </div>
                </div>
              </template>
            </Card>

            <Card containerClass="mb-5 shadow-sm" bodyClass="py-3" titleContainerClass="d-flex justify-content-center">
              <template #cardBody>
                <div class="d-flex justify-content-between align-items-center">
                  <span class="fs-3 fw-bold">{{$t('absences.setting.modals.plage_dates')}}</span>

                  <div class="form-check form-switch form-check-custom form-check-solid">
                    <input class="form-check-input" type="checkbox" v-model="formData.interval" id="flexSwitchDefault"/>
                  </div>
                </div>
              </template>
            </Card>

            <div class="row">
              <div class="col-md-12">
                <Input
                  container-class="form-group mb-5"
                  :name="`name`"
                  type="text"
                  :label="$t('absences.setting.name')"
                  labelClass="form-label fs-6 text-black"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  size="lg"
                  :isRequired="false" 
                  v-model="formData.name"
                />
              </div>
            </div>

            <div class="row">
              <InputDate
                containerClass="mt-5 form-group mb-5 col-12 col-md-6 col-lg-6"
                :name="'start_date'+id"
                type="text"
                :label="$t('absences.setting.start_date')"
                labelClass="form-label fs-6 text-black"
                :inputClass="'form-control form-control-sm form-control-solid'"
                :isRequired="false" 
                size="lg"
                :placeholder="$t('absences.setting.start_date')"
                 v-model="formData.start_date"
              />

              <InputDate
                containerClass="mt-5 form-group mb-5 col-12 col-md-6 col-lg-6"
                :name="'end_date'+id"
                type="text"
                :label="$t('absences.setting.end_date')"
                labelClass="form-label fs-6 text-black"
                :inputClass="'form-control form-control-sm form-control-solid'"
                :isRequired="false" 
                size="lg"
                :placeholder="$t('absences.setting.end_date')"
                 v-model="formData.end_date"
              />
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="d-flex flex-column mb-8">
                  <label class="required form-label fs-6 fw-bolder text-black mb-2">{{$t('absences.setting.description')}}</label>
                  <textarea class="form-control form-control-solid" rows="3" :name="'description'+id" v-model="formData.description" :placeholder="$t('absences.setting.description')"></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import {ref, defineEmits, defineProps, computed, onMounted} from "vue";
import Input from "@/components/Input.vue";
import Button from "@/components/Button.vue"
import RequiredText from "@/components/RequiredText.vue";
import Card from "@/Modules/Financial/components/Card.vue";
import InputDate from "@/components/InputDate.vue";
import {useStore} from "vuex";

const emits = defineEmits(['load'])

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  form: {
    type: Object,
    default: {
      id: '',
      name: '',
      start_date: '',
      end_date: '',
      description: '',
      interval: false,
      constant: false,
      country_id: ''
    }
  },
  edit: {
    type: Boolean,
    default: false
  }
})

const store = useStore()
const isLoading = ref(false)

const formData = ref(props.form)

function closeModal(){
  $('#'+props.id).modal('toggle')
}

function submitForm(){
  isLoading.value = true
    if(!props.edit){
      store.dispatch('holydays/createPublicHoliday', formData.value)
        .then((response) => {
            isLoading.value = false
            emits('load')
            closeModal()
            formData.value.name = '',
            formData.value.start_date = '',
            formData.value.end_date = '',
            formData.value.description = ''
            formData.value.interval = false
            formData.value.constant = false

            window.toastr['success'](i18n.global.t('absences.setting.public_holidays_created_successfully'))
        })
        .catch(err => {
            isLoading.value = false
        })
    }else{
      store.dispatch('holydays/updatePublicHoliday', formData.value)
        .then((response) => {
            isLoading.value = false
            emits('load')
            closeModal()
            formData.value.name = '',
            formData.value.start_date = '',
            formData.value.end_date = '',
            formData.value.description = '',
            formData.value.interval = false,
            formData.value.constant = false

            window.toastr['success'](i18n.global.t('absences.setting.public_holidays_updated_successfully'))
        })
        .catch(err => {
            isLoading.value = false
        })
    }
}
</script>

<style scoped>
.icon-wrapper {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-wrapper i {
  position: relative;
  font-size: 1.5em;
}

.icon-wrapper .icon-text {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  color: white;
  margin-top: 8px;
}
</style>